<template>
    <div class="exercise">
        <Navbar />
        <v-content>
            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 md6 lg3 v-if="exercise.name">
                        <h3>Name</h3>
                        <p>{{exercise.name}}</p>
                    </v-flex>
                    <v-flex xs12 md6 lg3 v-if="exercise.login_code">
                        <h3>Login Code</h3>
                        <p>{{exercise.login_code}}</p>
                    </v-flex>
                    <v-flex xs12 md6 lg3 v-if="exercise.start_date">
                        <h3>Start of exercise</h3>
                        <p>{{exercise.start_date.slice(0,10)}}</p>
                    </v-flex>
                    <v-flex xs12 md6 lg3 v-if="exercise.end_date">
                        <h3>End of exercise</h3>
                        <p>{{exercise.end_date.slice(0,10)}}</p>
                    </v-flex>
                </v-layout>
                <v-layout row wrap justify-center>
                    <v-flex xs12 md6 lg3>
                        <v-card height="100%" @click.native="$router.push('/exercises/' + exercise.id + '/teams')">
                            <v-card-title primary-title>
                                <h3>Teams</h3>
                            </v-card-title>
                            <v-card-text>
                                Manage teams taking part in the exercise.
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md6 lg3>
                        <v-card height="100%" @click.native="$router.push('/exercises/' + exercise.id + '/roleplayers')">
                            <v-card-title primary-title>
                                <h3>Roleplayer</h3>
                            </v-card-title>
                            <v-card-text>
                                Manage roleplayers taking part in the exercise.
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md6 lg3>
                        <v-card height="100%" @click.native="finishAllInjects()">
                            <v-card-title primary-title>
                                <h3>Finish Injects</h3>
                            </v-card-title>
                            <v-card-text>
                                Finish all currently running injects.
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <v-snackbar v-model="notExists" :right="true">
            Exercise can't be loaded.
            <v-btn color="pink" flat @click="notExists = false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import Navbar from '@/components/Navbar.vue'
    import axios from 'axios';
    axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

    export default {
        data() {
            return {
                exercise: {
                    id: '',
                    name: '',
                    login_code: '',
                    start_date: '',
                    end_date: ''
                },
                notExists: false
            }
        },
        components: {
            Navbar
        },
        methods: {
            loadExercise() {
                var exerciseID = this.$route.params.id
                axios.get('/exercises/' + exerciseID).then(response => {
                    this.exercise = response.data
                }).catch(error => {
                    this.notExists = true
                })
            },
            finishAllInjects() {
                if (confirm("Are you sure you want to finish all running injects for this exercise?")) {
                    var exerciseID = this.$route.params.id
                    axios.put('/exercises/' +  exerciseID + '/finish_all_injects').then(response => {}).catch(error => {})
                } 
            }
        },
        mounted() {
            this.loadExercise();
        }
    }
</script>